export const parseErrorArrayAndThrowMsg =
  (defaultMessage = 'unknown') =>
  err => {
    const errors = err?.response?.data?.errors;
    const errorMessage = errors ? errors.join('\n') : defaultMessage;
    throw new Error(errorMessage);
  };
